import { Injectable } from '@angular/core';
import { SocketService } from './socket.service';
import { Observable } from 'rxjs';
import { DataService } from './data.service';

@Injectable()
export class ChatService {

  private socketType = 'msgSocket';

  constructor(public _data: DataService,
    private _socket: SocketService) {}

  public open(): void {
    const deskId = this._data.session["desk"];
    this._socket.initSocket(deskId, this.socketType);
  }

  public close(): void {
    this._socket.clearSocket(this.socketType);
  }

  public sendMessage(message: any): void {
    this._socket.send(message, this.socketType);
  }

  public onMessage(): Observable<any> {
    return this._socket.getMessageObservable(this.socketType);
  }

  public onOpen(): Observable<any> {
    return this._socket.getOpenObservable(this.socketType);
  }

  public onClose(): Observable<any> {
    return this._socket.getCloseObservable(this.socketType);
  }
}
